<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: cn1994
 * @LastEditTime: 2024-09-24 16:22:29
 * @Description: 按钮组件
-->
<template>
  <el-button :type="type" :size="size" :icon="icon" :loading="loading" :disabled="disabled" @click="handleClick">
    <slot></slot>
  </el-button>
</template>

<script>

import mixin from './index.js'

export default {
  name: 'LsButton',
  componentName: 'LsButton',
  mixins: [mixin],
  props: {
    size: {
      type: String,
      default: 'small',
      validator: (val) => ['mini', 'small', 'medium', 'large'].includes(val),
    },
    type: {
      type: String,
      default: '',
      validator: (val) => ['primary', 'text', 'success', 'info', 'warning', 'danger', ''].includes(val),
    },
    icon: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>